import { TranscodingState, TranscodingJob, TranscodeRequestData } from '@/store/types/transcoding'

import { initRequestHelper, isAlreadyPending } from '@/store/root'

import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { RootState } from '../types/root'
import {
  apiTranscodeFile,
  // apiListTranscodingJobs,
  apiDeleteTranscodingJob,
} from '@/api/transcoding'

import { db } from '@/db'
import { firestoreAction } from 'vuexfire'
import { getCurrentUserUid } from '@/services/auth'
import firebase from 'firebase' // for typing Snapshot

const getDefaultState = (): TranscodingState => {
  return {
    jobs: null,
  }
}

const moduleState = getDefaultState()

const moduleGetters: GetterTree<TranscodingState, RootState> = {
  jobs(state) {
    return state.jobs
  },
  visibleJobs(state) {
    return state.jobs?.filter((job) => !job.deleted)
  },
  fileTranscodeRequest(_state, _getters, rootState) {
    return rootState.requests.fileTranscode
  },
  listTranscodingJobsRequest(_state, _getters, rootState) {
    return rootState.requests.listTranscodingJobs
  },
  listTranscodingJobsRequestPending(_state, getters) {
    return isAlreadyPending(getters.listTranscodingJobsRequest)
  },
  deleteTranscodingJobRequest(_state, _getters, rootState) {
    return rootState.requests.deleteTranscodingJob
  },
  deleteTranscodingJobRequestPending(_state, getters) {
    return isAlreadyPending(getters.deleteTranscodingJobRequest)
  },
}

const moduleActions: ActionTree<TranscodingState, RootState> = {
  async transcodeFile({ commit, getters }, transcodeData: TranscodeRequestData) {
    if (isAlreadyPending(getters.fileTranscodeRequest)) return
    const [setSuccess, setFailure] = initRequestHelper(commit, 'fileTranscode')
    try {
      await apiTranscodeFile(transcodeData)

      setSuccess('The file was submitted for transcoding!')
    } catch (err: any) {
      setFailure(err.message)
    }
  },

  async listJobs({ commit, getters, dispatch }) {
    if (isAlreadyPending(getters.listTranscodingJobsRequest)) return
    const [setSuccess, setFailure] = initRequestHelper(commit, 'listTranscodingJobs')

    try {
      // const jobs = await apiListTranscodingJobs()

      await dispatch('bindJobs')

      setSuccess()
    } catch (err: any) {
      setFailure(err.message)
    }
  },

  bindJobs: firestoreAction(({ bindFirestoreRef, state }) => {
    // avoid rebinding when unnecessary
    if (state.jobs !== null) return
    const uid = getCurrentUserUid()

    // Visible job secret on doc => hide it through serialize.
    const serialize = (snapshot: firebase.firestore.DocumentSnapshot) => {
      const docData = snapshot.data() as TranscodingJob
      const { secret, ...everythingElse } = docData
      return everythingElse
    }

    return bindFirestoreRef(
      'jobs',
      db.collection('transcoding_jobs').where('owner_id', '==', uid),
      { wait: true, serialize },
    )
  }),

  // TODO: support multi-delete
  async deleteJob({ commit, getters }, uuid: string): Promise<any> {
    if (isAlreadyPending(getters.deleteTranscodingJob)) return
    const [setSuccess, setFailure] = initRequestHelper(commit, 'deleteTranscodingJob')
    try {
      await apiDeleteTranscodingJob(uuid)

      setSuccess()
    } catch (err: any) {
      setFailure(err.message)
    }
  },
  resetTranscodingState({ commit }) {
    commit('RESET_TRANSCODING_STATE')
  },
}

const moduleMutations: MutationTree<TranscodingState> = {
  SET_JOBS(state, jobs) {
    state.jobs = jobs
  },
  RESET_TRANSCODING_STATE(state) {
    Object.assign(state, getDefaultState())
  },
}

const file: Module<TranscodingState, RootState> = {
  namespaced: true,
  state: moduleState,
  getters: moduleGetters,
  actions: moduleActions,
  mutations: moduleMutations,
}
export default file
